import { FormsPortalWorkspace } from '@/features/forms-portal/components/FormsPortalWorkspace';

export function FormsPortalPage() {
  return (
    <section className="page-card forms-portal-page">
      <FormsPortalWorkspace headerEyebrow="Assigned Forms" headerTitle="Forms Portal" />
    </section>
  );
}
